class EventEmitter extends EventTarget {}
export const eventEmitter = new EventEmitter();
